import type { LinearProgressProps } from '@mui/material/LinearProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { tss } from 'tss-react/mui';

export interface Or2DialogProgressBarProps extends LinearProgressProps {
  loading?: boolean | undefined;
}

const useStyles = tss.create(({ theme }) => {
  return {
    progressWrapper: {
      height: theme.spacing(0.5),
      marginTop: -theme.spacing(0.5),
    },
  };
});

export function Or2DialogProgressBar({
  loading,
  ...other
}: Or2DialogProgressBarProps) {
  const { classes } = useStyles();
  return (
    <div className={classes.progressWrapper}>
      {loading && <LinearProgress {...other} />}
    </div>
  );
}
